
import React from "react";
import { Box } from "@mui/material";

import AnnouncementResponseListItem from "./AnnouncementResponseListItem";
import EmptyResult from "components/Shared/Lottie/EmptyResult";

const AnnouncementResponseList = ({
    responses = [],
    onEditAction = () => { },

}) => {

    const _sortedResponses = [...responses]?.sort((a, b) =>
        a?.createdAt > b?.createdAt ? -1 : 1
    );

    return (
        <Box paddingX={3}>
            {!!_sortedResponses?.length ? (
                _sortedResponses?.map((response) => {

                    return (
                        <React.Fragment key={response?._id}>

                            <Box>
                                <AnnouncementResponseListItem response={response} onEditAction={onEditAction} />
                            </Box>

                        </React.Fragment>

                    );
                })
            ) : (
                <EmptyResult height={150} />
            )}
        </Box>
    );
};

export default AnnouncementResponseList;